document.addEventListener('DOMContentLoaded', function () {
  var splide = new Splide('#product-carousel', {
    type      : 'loop',
    perPage   : 4,
    perMove   : 1,
    arrows    : true,
    pagination: false,
    drag      : true,
    autoplay  : true,
    interval  : 2000,
    speed     : 2000,
    easing    : 'linear', // Added for linear scrolling
    pauseOnHover: false, // Disable default pause on hover
    breakpoints: {
      1024: {
        perPage: 4,
        speed: 2000,
        easing: 'linear', // Added for linear scrolling
        drag : false,
      },
      640: {
        perPage: 1,
        speed: 1500,
        easing: 'linear', // Added for linear scrolling
        drag : false,
        
      },
      320: {
        perPage: 1,
        speed: 1500,
        easing: 'linear', // Added for linear scrolling
        drag : false,
      },
    },
  }).mount();

  var playPauseBtn = document.getElementById('play-pause-btn');
  var isPlaying = true;

  playPauseBtn.addEventListener('click', function () {
    if (isPlaying) {
      splide.Components.Autoplay.pause();
      playPauseBtn.innerHTML = '<svg height="512px" id="Layer_1" style="enable-background:new 0 0 512 512;" version="1.1" viewBox="0 0 512 512" width="512px" xml:space="preserve" xmlns="http://www.w3.org/1999/xlink"><path d="M405.2,232.9L126.8,67.2c-3.4-2-6.9-3.2-10.9-3.2c-10.9,0-19.8,9-19.8,20H96v344h0.1c0,11,8.9,20,19.8,20  c4.1,0,7.5-1.4,11.2-3.4l278.1-165.5c6.6-5.5,10.8-13.8,10.8-23.1C416,246.7,411.8,238.5,405.2,232.9z"/></svg>';
    } else {
      splide.Components.Autoplay.play();
      playPauseBtn.innerHTML = '<svg height="512px" id="Layer_1" style="enable-background:new 0 0 512 512;" version="1.1" viewBox="0 0 512 512" width="512px" xml:space="preserve" xmlns="http://www.w3.org/1999/xlink"><g><path d="M224,435.8V76.1c0-6.7-5.4-12.1-12.2-12.1h-71.6c-6.8,0-12.2,5.4-12.2,12.1v359.7c0,6.7,5.4,12.2,12.2,12.2h71.6   C218.6,448,224,442.6,224,435.8z"/><path d="M371.8,64h-71.6c-6.7,0-12.2,5.4-12.2,12.1v359.7c0,6.7,5.4,12.2,12.2,12.2h71.6c6.7,0,12.2-5.4,12.2-12.2V76.1   C384,69.4,378.6,64,371.8,64z"/></g></svg>';
    }
    isPlaying = !isPlaying;
  });

  var splideElement = document.getElementById('product-carousel');
  
  splideElement.addEventListener('mouseover', function () {
    splide.Components.Autoplay.pause();
  });

  splideElement.addEventListener('mouseleave', function () {
    if (isPlaying) {
      splide.Components.Autoplay.play();
    }
  });
});


document.addEventListener('DOMContentLoaded', function () {
  var splide = new Splide('#category-carousel', {
    type      : 'loop',
    perPage   : 1,
    perMove   : 1,
    arrows    : true,
    pagination: false,
    drag      : true,
    autoplay  : true, 
    speed     : 5000, 
    pauseOnHover: false,
    breakpoints: {
      1024: {
        perPage: 1,
        speed: 2000, 
           drag : false,
      },
      640: {
        perPage: 1,
        speed: 1500, 
        drag : false,
      },
      320: {
        perPage: 1,
        speed: 1500, 
        drag : false,
      },
    },
  }).mount();

  var playPauseBtn = document.getElementById('play-pause-btn1');
  var isPlaying = true;

  playPauseBtn.addEventListener('click', function () {
    if (isPlaying) {
      splide.Components.Autoplay.pause();
      playPauseBtn.innerHTML = '<svg height="512px" id="Layer_1" style="enable-background:new 0 0 512 512;" version="1.1" viewBox="0 0 512 512" width="512px" xml:space="preserve" xmlns="http://www.w3.org/1999/xlink"><path d="M405.2,232.9L126.8,67.2c-3.4-2-6.9-3.2-10.9-3.2c-10.9,0-19.8,9-19.8,20H96v344h0.1c0,11,8.9,20,19.8,20  c4.1,0,7.5-1.4,11.2-3.4l278.1-165.5c6.6-5.5,10.8-13.8,10.8-23.1C416,246.7,411.8,238.5,405.2,232.9z"/></svg>';
    } else {
      splide.Components.Autoplay.play();
      playPauseBtn.innerHTML = '<svg height="512px" id="Layer_1" style="enable-background:new 0 0 512 512;" version="1.1" viewBox="0 0 512 512" width="512px" xml:space="preserve" xmlns="http://www.w3.org/1999/xlink"><g><path d="M224,435.8V76.1c0-6.7-5.4-12.1-12.2-12.1h-71.6c-6.8,0-12.2,5.4-12.2,12.1v359.7c0,6.7,5.4,12.2,12.2,12.2h71.6   C218.6,448,224,442.6,224,435.8z"/><path d="M371.8,64h-71.6c-6.7,0-12.2,5.4-12.2,12.1v359.7c0,6.7,5.4,12.2,12.2,12.2h71.6c6.7,0,12.2-5.4,12.2-12.2V76.1   C384,69.4,378.6,64,371.8,64z"/></g></svg>';
    }
    isPlaying = !isPlaying;
  });

  // Update slide number and title
  splide.on('move', function(newIndex) {
    document.getElementById('slide-number').textContent = (newIndex + 1) + '/' + splide.length;
    document.getElementById('slide-title').textContent = splide.Components.Elements.slides[newIndex].getAttribute('data-title');
  });

  // Initialize slide number and title
  document.getElementById('slide-number').textContent = '1/' + splide.length;
  document.getElementById('slide-title').textContent = splide.Components.Elements.slides[0].getAttribute('data-title');
});


 $('.swiper-wrapper1').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  prevArrow: '<div class="leftArrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40" focusable="false"><path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path></svg></div>',
  nextArrow: '<div class="rightArrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40" focusable="false"><path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path></svg></div>',
  fade: true,
  asNavFor: '.swiper-wrapper3'
});
$('.swiper-wrapper3').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  asNavFor: '.swiper-wrapper1',
  dots: false,
  arrows: false,
  centerMode: false,
  focusOnSelect: true
});

// menu go back button
$(document).ready(function() {
  $('.go-back a').click(function(e) {
        e.preventDefault();
        var currentSubMenuBlock = $(this).closest('.sub-menu-block');
        currentSubMenuBlock.removeClass('active').addClass('is-hidden');
        currentSubMenuBlock.parent().closest('.sub-menu-block').removeClass('is-hidden').addClass('active');
    });

 $('.menu-item-has-children > a').click(function(e) {
        e.preventDefault();
        var subMenuBlock = $(this).siblings('.sub-menu-block');
        if (subMenuBlock.length) {
            $(this).parent('li').siblings().find('.sub-menu-block.active').removeClass('active').addClass('is-hidden');
            subMenuBlock.removeClass('is-hidden').addClass('active');
        }
    });


// ==========================
// pin to zoom
if (jQuery(window).width() < 767) {
let sliderZoomInstances = [];

let currentSlideIndex;
  jQuery('.swiper-container.main-swiper-container .swiper-slide img.product-item-img').each(function () {
    let $this = this;
    let $$this = jQuery(this);
    let slideId = $$this.closest('.swiper-slide').attr('id');
    
    let throttleTimer;
    currentSlideIndex = $this.closest('.swiper-container').swiper.activeIndex;

    let overlay = jQuery('<div class="zoom-overlay" style="position:absolute;top:0;bottom:0;left:0;right:0;background-color: #00800000;"></div>');
    $$this.parent().after(overlay);

    // overlay.on('touchstart', function () {
    //     // let id = jQuery(this).closest('.swiper-slide').attr('id');
    //     // sliderZoomInstances[id].pz.zoomIn(); 
    //     overlay.hide();  
    // });

    let startDistance = 0;
    // return;
    
    overlay.on("touchstart", function (e) {
        if (e.originalEvent.touches.length === 2) {
            let [touch1, touch2] = e.originalEvent.touches;

            startDistance = Math.hypot(
                touch2.pageX - touch1.pageX,
                touch2.pageY - touch1.pageY
            );
        }
    });

    overlay.on("touchmove", function (e) {
        if (e.originalEvent.touches.length === 2) {
            let [touch1, touch2] = e.originalEvent.touches;

            let currentDistance = Math.hypot(
                touch2.pageX - touch1.pageX,
                touch2.pageY - touch1.pageY
            );

            if (currentDistance > startDistance) {
                console.log("Zoom In detected");
                overlay.hide();  
            } else if (currentDistance < startDistance) {
                overlay.hide();    
              console.log("Zoom Out detected");
            }

            startDistance = currentDistance;
        }
    });
    
    let sliderZoom = Panzoom($this, {
        setTransform: ($this, { scale, x, y }) => {
            console.log('Current scale:', sliderZoom.getScale(),'New scale:', scale);
            console.log('Current x:', sliderZoom.getPan().x, 'New x:', x);
          console.log('Current y:', sliderZoom.getPan().y, 'New y:', y);

          if (sliderZoom.getScale() === scale) {
              overlay.show();
              return;
          }
          
            if (!throttleTimer) {
                throttleTimer = setTimeout(() => {
                    let swiper = $this.closest('.swiper-container').swiper;
                    if (sliderZoom.getScale() === scale) {
                        overlay.show();
                        // if (sliderZoom.getPan().x < x && swiper.activeIndex === currentSlideIndex) {
                        //     console.log('Triggering slideNext');
                        //     swiper.slideNext();
                        //     currentSlideIndex = swiper.activeIndex;
                        // } else if (sliderZoom.getPan().x > x && swiper.activeIndex === currentSlideIndex) {
                        //     console.log('Triggering slidePrev');
                        //     swiper.slidePrev();
                        //     currentSlideIndex = swiper.activeIndex;
                        // }
                    }
                    throttleTimer = null;
                }, 300);
            }

            let scalemod = scale < 1 ? 1 : scale;
            let trans = scale > 1 ? `translate(${x}px, ${y}px)` : '';
            sliderZoom.setStyle('transform', `scale(${scalemod}) ${trans}`);
            console.log(`Applied transform: scale(${scalemod}) ${trans}`);

            const rect = $this.getBoundingClientRect();
            const parentRect = $this.parentElement.getBoundingClientRect();
            console.log('Image rect:', rect);
            console.log('Parent rect:', parentRect);

            if (rect.right < parentRect.left && swiper.activeIndex === currentSlideIndex) {
                console.log('Image moved out of bounds on the right, sliding to next.');
                swiper.slideNext();
                currentSlideIndex = swiper.activeIndex;
                sliderZoom.reset();
            } else if (rect.left > parentRect.right && swiper.activeIndex === currentSlideIndex) {
                console.log('Image moved out of bounds on the left, sliding to previous.');
                swiper.slidePrev();
                currentSlideIndex = swiper.activeIndex;
                sliderZoom.reset();
            }
        }
    });
    sliderZoomInstances[slideId] = {el:$$this,pz:sliderZoom};
});
  
jQuery('.swiper-container.swiper-gallery-inline-slider').each(function () {
    if (this.swiper) {
        this.swiper.on('slideChange', function () {
          currentSlideIndex = this.activeIndex;
          // console.log('all instances',sliderZoomInstances);
          
            sliderZoomInstances.forEach(item => {
                // console.log('fdfd',pz);
                item.pz.reset();
            });
        });
    }
});
}  
// ==========================
});

jQuery(document).on('click', function(event) {
  if (!jQuery(event.target).closest('.drawer-sidebar .sidebar, .drawer_filter_action').length) {
    jQuery('.drawer-sidebar').removeClass('open');
  }
});

jQuery('a.drawer_filter_action.dt-sc-btn').click(function(){
    jQuery('.drawer-sidebar').addClass('open');
});

 

jQuery(document).ready(function() {
    jQuery('.product-tab .dt-sc-accordion-btn').addClass('open');
});
